import { createFileRoute, Navigate } from '@tanstack/react-router';

const SettingsIntegrationsRedirect = () => <Navigate to="/settings/phone" replace />;

export const Route = createFileRoute('/_authenticated/_app/settings/integrations')({
  component: SettingsIntegrationsRedirect,
});
